import { render } from "./DownloadedFiles.vue?vue&type=template&id=dbfe8692&scoped=true&ts=true&lang=pug"
import script from "./DownloadedFiles.vue?vue&type=script&lang=ts"
export * from "./DownloadedFiles.vue?vue&type=script&lang=ts"

import "./DownloadedFiles.vue?vue&type=style&index=0&id=dbfe8692&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbfe8692"]])

export default __exports__